import { render, staticRenderFns } from "./ShippingDate.vue?vue&type=template&id=58a575ae&scoped=true&"
import script from "./ShippingDate.vue?vue&type=script&lang=js&"
export * from "./ShippingDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a575ae",
  null
  
)

export default component.exports